module.exports = __webpack_public_path__ + "img/Marca10.ece28092.jpg";